// Debounced background save with an explicit flush. Pure (no React) so the timing rules are unit-testable:
//   schedule(payload) — remember the latest payload and (re)start the timer; the last payload wins
//   flush()           — save whatever is pending right now (used when the applicant leaves the step)
//   cancel()          — drop the pending payload (used right before an explicit save on Continue)
export function createAutosaver(save, step, delayMs = 2000) {
  let timer = null; let pending; let hasPending = false;
  const clear = () => { if (timer) { clearTimeout(timer); timer = null; } };
  const fire = () => {
    clear(); if (!hasPending) return;
    const payload = pending; pending = undefined; hasPending = false;
    try { Promise.resolve(save(step, payload)).catch(() => {}); } catch (_) { /* a failing background save never breaks the wizard; Continue re-saves explicitly */ }
  };
  return {
    schedule(payload) { pending = payload; hasPending = true; clear(); timer = setTimeout(fire, delayMs); },
    flush() { fire(); },
    cancel() { pending = undefined; hasPending = false; clear(); },
  };
}
